import Env from 'env-service'

/**
 * Tagged Template Literal function for setting business service domains depending on the environment
 */
function decorateWithServicesDomain(strings, ...subStrings) {
  return _taggedUrlHelper({ 
    strings, 
    subStrings, 
    protocol: 'https://', 
    subdomain: 'wsa'
  })
}

/**
 * Tagged Template Literal function for setting CDN-backed business service domains depending on the environment
 */
function decorateWithCDNServicesDomain(strings, ...subStrings) {
  return _taggedUrlHelper({ 
    strings, 
    subStrings, 
    protocol: 'https://', 
    subdomain: 'cdn-wsa'
  })
}

/**
 * Tagged Template Literal function for setting inventory service domains depending on the environment
 */
function decorateWithInventoryDomain(strings, ...subStrings) {
  return _taggedUrlHelper({ 
    strings, 
    subStrings, 
    protocol: 'https://', 
    subdomain: 'inventory'
  })
}

/**
 * Tagged Template Literal function for setting content domains depending on the environment
 */
function decorateWithContentServerDomain(strings, ...subStrings) {
  return _taggedUrlHelper({ 
    strings, 
    subStrings, 
    protocol: 'https://', 
    subdomain: 'content'
  })
}

/**
 * Tagged Template Literal function for setting ad domains depending on the environment
 */
function decorateWithAdServerDomain(strings, ...subStrings) {
  // this url purposefully does not include a protocol since the protocol is
  // handled further down the line in processing
  return _taggedUrlHelper({ 
    strings, 
    subStrings, 
    protocol: '', 
    subdomain: 'ad'
  })
}

/**
 * Tagged Template Literal function for tracking domain depending on the environment
 */
function decorateWithTrackingDomain(strings, ...subStrings) {
  // this url purposefully does not include a protocol since the protocol is
  // handled further down the line in processing
  return _taggedUrlHelper({ 
    strings, 
    subStrings, 
    protocol: 'https://', 
    subdomain: 'strtrk'
  })
}

/**
 * Tagged Template Literal function for application domain depending on the environment
 */
function decorateWithApplicationDomain(strings, ...subStrings) {
  // this url purposefully does not include a protocol since the protocol is
  // handled further down the line in processing
  return _taggedUrlHelper({ 
    strings, 
    subStrings, 
    protocol: 'https://', 
    subdomain: 'go'
  })
}

/**
 * Tagged Template Literal function for client side rendering domain depending on the environment
 */
function decorateWithCSRDomain(strings, ...subStrings) {
  // this url purposefully does not include a protocol since the protocol is
  // handled further down the line in processing
  return _taggedUrlHelper({ 
    strings, 
    subStrings, 
    protocol: 'https://', 
    subdomain: 'csr'
  })
}


// Private function to handle tagged template literal input that is a path
// and return a full url based on environement
function _taggedUrlHelper(settings){
  const { strings, subStrings, protocol, subdomain } = settings
  
  let result = strings.raw[0]
  for (const [i, subStr] of subStrings.entries()) {
    result += subStr
    result += strings.raw[i + 1]
  }

  const missingSlash = result.length && result.charAt(0) !== '/' ? '/' : ''
  
  return `${protocol}${!Env.IS_PRODUCTION_CONNECTION ? 'staging-' : ''}${subdomain}.adacado.com${missingSlash}${result}`
}


export default {
    decorateWithServicesDomain,       //formerly provideLocalAccess
    decorateWithCDNServicesDomain,
    decorateWithInventoryDomain,
    decorateWithContentServerDomain,  //formerly envSpecificContentDomain
    decorateWithAdServerDomain,       //formerly envSpecificAdDomain
    decorateWithTrackingDomain,
    decorateWithApplicationDomain,
    decorateWithCSRDomain,
}
